import { Dispatch, SetStateAction } from "react";
import { Modal } from "@JohnLewisPartnership/jl-design-system/dist/components/modal/Modal";
import { GalleryObject } from "../utils/utils.ts";
import { Carousel } from "./Carousel";
import styles from "./ZoomModal.module.scss";

export interface ZoomModalProps {
  closeZoomModal: () => void;
  mediaItems: GalleryObject[];
  selectedIndex: number;
  setSelectedIndex: Dispatch<SetStateAction<number>>;
  isZoomModalOpen: boolean;
  videoAutoplayIndex: number | null;
}

export const ZoomModal = ({
  closeZoomModal,
  mediaItems,
  selectedIndex,
  setSelectedIndex,
  isZoomModalOpen,
  videoAutoplayIndex,
}: ZoomModalProps) => {
  return (
    <Modal
      isOpen={isZoomModalOpen}
      height="fixed"
      headerType="empty"
      variant="full-screen"
      footer={false}
      width="extra-large"
      onClose={closeZoomModal}
      className={styles.galleryContainer}
    >
      <Carousel
        mediaItems={mediaItems}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
        closeZoomModal={closeZoomModal}
        videoAutoplayIndex={videoAutoplayIndex}
      />
    </Modal>
  );
};
